import {
  aes128gcm,
  getJwkKeystore,
  getTransKey,
  JWE_KEY,
  KEYSTORE,
} from '../../utils/encryption';

import {
  login,
  loginSuccess,
  loginError,
} from '../../Shared/UserContext/Actions';

import { confAxios } from '../../config/api';
import { applyPreferredLanguage } from '../../i18n';

export const loginUser = async (dispatch, credential, history) => {
  try {
    const transKey = await getTransKey();

    const bodyFormData = new FormData();
    bodyFormData.set('username', credential.username);
    bodyFormData.set('password', credential.password);

    if (process.env.REACT_APP_JWE !== 'false') {
      bodyFormData.set('transKey', transKey.encrypted);
    }

    dispatch(login());
    

    const response = await fetch(`${confAxios.baseURL}/login`, {
      method: 'POST',
      body: bodyFormData,
    });

    
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Login failed');
    }
    
    const data = await response.json();
    const { key, user, token, grayClient } = data;
    
    const logo = grayClient.image;
    await localStorage.setItem('logo', logo);
    localStorage.setItem('settings', JSON.stringify(grayClient));    
    
    if (process.env.REACT_APP_JWE !== 'false') {
      try {
        const aesCipher = await aes128gcm(Buffer.from(transKey.clair, "hex"));
        const keyJWE = await aesCipher.decrypt(
          Buffer.from(key.slice(0, 32), 'hex'),
          '0000000000000000',
          Buffer.from(key.slice(32, 64), 'hex'),
        );

        await localStorage.setItem(JWE_KEY, keyJWE);

        const keystore = await getJwkKeystore(keyJWE);
        // await localStorage.setItem(KEYSTORE, keystore.toString());

        await localStorage.setItem(KEYSTORE, JSON.stringify(keystore.toJSON(true))); 


      } catch (error) {
        console.error('Error during JWE key decryption:', error);
        throw error;
      }
    }


    dispatch(loginSuccess(user, token));
    applyPreferredLanguage(); 

    history.push("/");


  } catch (error) {
    const errorMessage = error.message;
    dispatch(loginError(errorMessage));
  }
};
